module.exports = __webpack_public_path__ + "img/section_6_asset.d41f8bf5.png";